import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetOne, useRedirect } from "react-admin";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  IconButton,
  Divider,
  Menu,
  MenuItem,
  Rating,
  TextField as MuiTextField,
} from "@mui/material";
import { MoreVert, Phone, Email, Star, AddComment, Female, Male, HelpOutline } from "@mui/icons-material";
import FormResponseList from "../../../Forms/components/Response/FormResponseList";

const getGenderIcon = (gender) => {
  if (gender?.toLowerCase() === "hombre") return <Male fontSize="small" />;
  if (gender?.toLowerCase() === "mujer") return <Female fontSize="small" />;
  return <HelpOutline fontSize="small" />;
};
const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
const InfoItem = ({ icon, label, value, countryCode }) => (
  <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
    <Box display="flex" alignItems="center">
      {icon}
      <Typography variant="body2" fontWeight="bold" sx={{ ml: 1 }}>
        {label}:
      </Typography>
    </Box>
    <Typography variant="body2">{value}</Typography>
  </Box>
);
const CustomerFormsPage = () => {
  const { id } = useParams();
  const { data: customer } = useGetOne("enterprise/customers", { id });
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const redirect = useRedirect();
  const [detail, setDetail] = useState(customer?.detail || "");
  useEffect(() => {
    setDetail(customer?.detail || "");
  }, [customer]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3} sx={{ mt: 3 }}>
        <Card>
          <CardContent>
            {/* Encabezado con nombre y menú */}
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="h6" fontWeight="bold">
                  {customer?.fullName || "Cliente Desconocido"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Cliente registrado
                </Typography>
              </Box>
              <IconButton onClick={handleMenuOpen}>
                <MoreVert />
              </IconButton>
            </Box>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
              <MenuItem onClick={() => redirect(`/enterprise/customers/${id}`)}>Editar</MenuItem>
            </Menu>

            <Divider sx={{ my: 2, bgcolor: "rgba(0, 0, 0, 0.1)" }} />
            <Box mt={2}>
              <InfoItem
                icon={<Phone fontSize="small" />}
                label="Teléfono"
                value={customer?.phone || "No disponible"}
                countryCode={customer?.countryCode}
              />
              <InfoItem icon={<Email fontSize="small" />} label="Correo" value={customer?.email || "No disponible"} />
              <InfoItem
                icon={getGenderIcon(customer?.gender)}
                label="Género"
                value={capitalizeFirstLetter(customer?.gender) || "No especificado"}
              />
              <InfoItem
                icon={<Star fontSize="small" />}
                label="Calificación"
                value={
                  customer?.rating === undefined ? (
                    "No tiene"
                  ) : (
                    <Rating
                      name="customer-rating"
                      value={customer?.rating || 0}
                      readOnly
                      precision={0.5} // Permite medias estrellas si es necesario
                      sx={{ fontSize: "1.5rem" }} // Ajusta el tamaño de las estrellas
                    />
                  )
                }
              />
              <Box mt={2}>
                <Box display="flex" alignItems="center">
                  <AddComment fontSize="small"></AddComment>
                  <Typography variant="body2" fontWeight="bold" sx={{ ml: 1 }}>
                    Detalles del cliente:
                  </Typography>
                </Box>
                <MuiTextField
                  label="Detalle"
                  fullWidth
                  multiline
                  rows={4}
                  value={detail}
                  onChange={(e) => setDetail(e.target.value)}
                  sx={{ mt: 2 }}
                  placeholder="Agrega un detalle..."
                />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={9}>
        {customer && customer._id && <FormResponseList customerId={customer._id} />}
      </Grid>
    </Grid>
  );
};
export default CustomerFormsPage;
